import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "61",
  height: "55",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M19.1.9a3.8 3.8 0 1 0 0 7.6h22.8a3.8 3.8 0 1 0 0-7.6zM7.7 16.1a3.8 3.8 0 0 1 3.8-3.8h38a3.8 3.8 0 1 1 0 7.6h-38a3.8 3.8 0 0 1-3.8-3.8M.1 31.3a7.6 7.6 0 0 1 7.6-7.6h45.6a7.6 7.6 0 0 1 7.6 7.6v15.2a7.6 7.6 0 0 1-7.6 7.6H7.7a7.6 7.6 0 0 1-7.6-7.6z"
    }, null, -1)
  ]))]))
}
export default { render: render }